


















import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop, Watch } from 'vue-property-decorator';
import { PageMeta } from '@/types/pagination';

@Component
export default class Pagination extends Mixins<SlotMixin>(SlotMixin) {
  @Prop() private meta!: PageMeta;
  page:number = 1;
  loading: boolean = false;

  // https://github.com/kaorun343/vue-property-decorator#Watch
  @Watch('meta', { immediate: true, deep: true })
  onMetaChanged (newMeta:PageMeta) {
    this.loading = false;
    this.page = newMeta.current_page;
  }
  @Watch('page')
  onPageChanged () {
    if (!this.loading && this.page !== this.meta.current_page) {
      this.loading = true;
      this.$router.push({ query: { ...this.$route.query, page: this.page.toString() } });
    }
  }
  created () {
    if (this.meta) {
      this.page = this.meta.current_page;
    }
  }
}
